export default "__VITE_ASSET__fea20f92__"